var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{attrs:{"action":"#","accept":".xls,.xlsx","show-file-list":false,"http-request":_vm.onChange,"before-upload":_vm.beforeAvatarUpload}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v(_vm._s(_vm.object.Object && _vm.object.Object.label ? _vm.object.Object.label : _vm.name))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }